__turbopack_context__.v({
  "brussels-airport": "ACReLa_brussels-airport",
  "bullet": "ACReLa_bullet",
  "bullets": "ACReLa_bullets",
  "how": "ACReLa_how",
  "platform": "ACReLa_platform",
  "section": "ACReLa_section",
  "sold-out": "ACReLa_sold-out",
  "stargate": "ACReLa_stargate",
  "stargate-section": "ACReLa_stargate-section",
  "step": "ACReLa_step",
  "steps": "ACReLa_steps",
  "v-centered-description": "ACReLa_v-centered-description",
  "why": "ACReLa_why",
});
